import {
  GetQuestionnaireAnswerResponse,
  GetQuestionnaireResponse
} from 'src/api/requests'

export const mapAnswersToQuizDetails = (
  questions?: GetQuestionnaireResponse,
  answers?: GetQuestionnaireAnswerResponse
) => {
  return {
    ...questions,
    questions: questions?.questions?.map((question) => {
      const matchedAnswer = answers?.find(
        (ans: GetQuestionnaireAnswerResponse) => ans?.id === question.id
      )

      const hasOther = question?.hasOther
      const otherChoiceId = question?.otherChoiceId

      return {
        ...question,
        answerChoices: [
          ...(question?.answerChoices?.map((choice) => ({
            ...choice,
            isSelected: matchedAnswer
              ? matchedAnswer?.choices?.some(
                  (ans: string) => ans === choice?.id
                )
              : false
          })) ?? []),
          ...(hasOther && otherChoiceId
            ? [
                {
                  id: otherChoiceId,
                  text: {
                    ro: matchedAnswer?.otherText,
                    ru: matchedAnswer?.otherText
                  },
                  isSelected:
                    matchedAnswer?.choices?.includes(otherChoiceId) || false
                }
              ]
            : [])
        ]
      }
    })
  }
}
